
import moment from 'moment'

export const getTimestamp = (timestamp: number): string => {
  const now = moment()
  const then = moment(timestamp)
  const diff = now.diff(then, 'minutes')

  if (diff < 1) return 'Gerade eben'
  if (diff < 60) return `vor ${diff} Min.`

  const hoursDiff = now.diff(then, 'hours')
  if (hoursDiff < 24) return `vor ${hoursDiff} Std.`

  const daysDiff = now.diff(then, 'days')
  if (daysDiff < 7) return `vor ${daysDiff} ${daysDiff === 1 ? 'Tag' : 'Tagen'}`

  return then.format('DD.MM.YYYY')
}
